import { PaymentCardType } from "@wingspanhq/payments/dist/interfaces";
import { PaymentCardListQuery } from "../../../services/payments";
import { useQueryPaymentsCards } from "./useQueryPaymentsCards";

export const useQueryPaymentsCardsDebit = (query?: PaymentCardListQuery) =>
  useQueryPaymentsCards({
    filter: { cartType: PaymentCardType.Debit },
    ...query
  });
